import { render, staticRenderFns } from "./Dm.vue?vue&type=template&id=af5c917a&scoped=true"
var script = {}
import style0 from "./Dm.vue?vue&type=style&index=0&id=af5c917a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c917a",
  null
  
)

export default component.exports